import { Injectable } from '@angular/core';

import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { GridInput } from '@it2go/data-grid';
import {
    BudgetChapterGridObject, BudgetChapterObject,
} from '@libs/types/src/mado/object-type/organization';
import { filterFrag } from './types/filter.types';
import { BudgetChapterCreateInput, BudgetChapterUpdateInput } from '@libs/types/src/mado/input-type/organization';

@Injectable({ providedIn: 'root' })
export class BudgetChapterGqlService extends GqlServiceV2 {

    public getBudgetChapters(input: GridInput | null, frag: string) {
        return this.query<BudgetChapterGridObject>(
            `
                query($input: GridInput!) {
                    budgetChapter {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createBudgetChapter(input: BudgetChapterCreateInput, frag: string) {
        return this.mutate<BudgetChapterObject>(
            `
                mutation($input: BudgetChapterCreateInput!) {
                    budgetChapter {
                        create(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public updateBudgetChapter(input: BudgetChapterUpdateInput, frag: string) {
        return this.mutate<BudgetChapterObject>(
            `
                mutation($input: BudgetChapterUpdateInput!) {
                    budgetChapter {
                        update(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }
}
